import React from "react";
import { Button } from "antd"; // Sử dụng thành phần của Ant Design
import { ArrowLeftOutlined } from "@ant-design/icons";

const ReturnButton = ({ setComponentDuocChon }) => {
  return (
    <Button
      type="link"
      onClick={() => setComponentDuocChon("dashboardBaoduongSuachua")}
      style={{ marginBottom: "10px", display: "flex", alignItems: "center" }}
    >
      <ArrowLeftOutlined style={{ marginRight: "5px" }} />
      Quay lại
    </Button>
  );
};

export default ReturnButton;
